import { Module } from 'vuex';
import { RootState, TeamCategory } from 'frontend/types';

interface CareersState {
  categories: TeamCategory[];
}

const careers: Module<CareersState, RootState> = {
  namespaced: true,
  state: {
    categories: [] as TeamCategory[],
  },
  mutations: {
    setValue(state: CareersState, value: CareersState): void {
      state.categories = value.categories;
    },
  },
};

export default careers;
